import { Card, CardContent, Typography, Box, useTheme } from '@mui/material'
import useCustomStyles from '../hooks/CustomStylesHook'
import Colors from '../utils/colors.json'

const styles = (theme: any) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
    padding: theme.spacing(2),
    // minWidth: 300,
  },
  icon: {
    width: 16,
    height: 16,
    backgroundColor: theme.palette.grey[400],
    borderRadius: '50%',
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: 16,
    fontWeight: 400,
    color: Colors.TEXT_COLOR_MAIN,
    marginBottom: theme.spacing(1),
  },
  value: {
    fontSize: 32,
    fontWeight: 400,
    color: Colors.TEXT_COLOR_SECONDARY,
  },
  unit: {
    fontSize: 20,
    fontWeight: 400,
    color: Colors.TEXT_COLOR_SECONDARY,
  },
  status: {
    fontSize: 12,
    fontWeight: 400,
    marginTop: theme.spacing(0.5),
    color: Colors.TEXT_COLOR_QUATERNARY,
  },
})

const VitalsCard = ({
  name,
  value,
  unit,
  note,
}: {
  name: string
  value: string
  unit: string
  note: string
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <Card className={classes?.card} elevation={0}>
      <CardContent>
        <Box
          display={'flex'}
          flexDirection={'row'}
          gap={1}
          justifyContent={'start'}
          alignItems={'center'}
        >
          <Box className={classes?.icon}></Box>
          <Typography className={classes?.title}>{name}</Typography>
        </Box>
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Box display='flex' alignItems='baseline'>
            <Typography className={classes?.value}>{value}</Typography>
            <Typography className={classes?.unit}>&nbsp;{unit}</Typography>
          </Box>
          <Typography
            variant='subtitle1'
            color='textSecondary'
            className={classes?.status}
          >
            {note}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  )
}

export default VitalsCard
